module.exports = __webpack_public_path__ + "img/exim.166e8177.svg";